export class FileUtils
{
	private static createURLFromData(content: BlobPart, type: string = "text/plain")
	{
		// This is slow for big text -> we use Blob instead.
		//var url = "data:text/plain;charset=utf-8," + encodeURIComponent(content);

		const blob = new Blob([content], {type: type});
		const url = URL.createObjectURL(blob);

		return url;
	}

	public static downloadFileGivenByData(content: BlobPart, defaultFileName: string, type: string = "text/plain")
	{
		const url = FileUtils.createURLFromData(content, type);
		FileUtils.downloadFileFromUrl(url, defaultFileName);
		URL.revokeObjectURL(url);
	}

	private static async downloadIntoDataURL(url: string)
	{
		const response = await fetch(url);
		const blob = await response.blob();

		return URL.createObjectURL(blob);
	}

	private static async downloadFileFromUrl(url: string, defaultFileName: string)
	{
		const a = document.createElement("a");

		// Need to convert images/txt into dataURL to force download images as opposed to just open them.
		a.href = await this.downloadIntoDataURL(url);

		// This doesn't seem to be working, filename is always render.png
		a.setAttribute("download", defaultFileName);
		a.download = defaultFileName;

		a.style.display = "none";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
}